// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"_3Cioj","large":"_34O0f","vertical":"_1ndBp","bullet":"qhpkW","a11y":"LgbeI","a11Y":"LgbeI"};